import React, { useEffect, useRef, useState, useContext } from "react";
import Footer11 from "../shared/Footer11";
import Navbar11 from "../shared/Navbar11";
import Sidebar11 from "../shared/Sidebar11";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { ContextBoard } from "../../context/ContextBoard";
import { getSessionData } from "../../cache";

function Checklistgenerated11() {
  const [pendingData, setPendingData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const navigate = useNavigate();

  const {
    setClass11Candidateid,
    setClass11Mode,
    setClass11Divyangcode,
    setClass11Castecode,
    setClass11JacStudent,
    setClass11OtherMode,
    setClass11otherstudent,
    setClass11exregularmode,
    setClass11exregulartudent,
    setClass11before2010mode,
    setClass11before2010,
  } = useContext(ContextBoard);
  const [EndDate, setEndDate] = useState("");
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const yeardate = date.getFullYear();
  const currentDate = `${day}-${month}-${yeardate}`;
  const parseDate = (str) => {
    const [dd, mm, yyyy] = str.split("-");
    return new Date(`${yyyy}-${mm}-${dd}`);
  };
  useEffect(() => {
    const fetchPendingData = async () => {
      try {
        const token = sessionStorage.getItem("tokenclassxi");

        const response = await fetch(
          `${config.API_BASE_URL}/FetchListChecklistGenerated_CL11`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();
        setIsLoading(false);
        if (response.ok) {
          setPendingData(result.data.checklistStatus || []);
        } else {
          console.error("API Error:", result.message);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Fetch error:", error);
      }
    };
    const cL11EndDate = getSessionData("cL11EndDate") || {};
    setEndDate(cL11EndDate?.cL_11_REGISTRATION_END_DATE || "");
    fetchPendingData();
  }, []);

  const filteredStudents = pendingData.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.gender?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.aadhaR_CARD?.toLowerCase().includes(query) ||
      student.checklisT_STATUS?.toLowerCase().includes(query) ||
      student.prinT_CATEGORY?.toLowerCase().includes(query) ||
      student.deO_STATUS?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleEdit = async (id) => {
    try {
      const token = sessionStorage.getItem("tokenclassxi");

      const response = await fetch(
        `${config.API_BASE_URL}/GetStudentByCandidateId_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            candidatE_ID: id,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched Candidate Data:", data);
      const student = data.data.editStudent_data;

      if (student.ediT_REDIRECTION === "JAC_Registration") {
        setClass11JacStudent(student);
        setClass11Candidateid(student.candidatE_ID);
        setClass11Castecode(student.cast);
        setClass11Divyangcode(student.divyang);
        setClass11Mode("edit");
        navigate("/class-xi-add-student-jac-page");
      } else if (student.ediT_REDIRECTION === "Others_Registration") {
        setClass11otherstudent(student);
        setClass11Candidateid(student.candidatE_ID);
        setClass11Castecode(student.cast);
        setClass11Divyangcode(student.divyang);
        setClass11OtherMode("edit");

        navigate("/class-xi-add-others-student");
      } else if (student.ediT_REDIRECTION === "EX_Registration") {
        setClass11exregulartudent(student);
        setClass11Candidateid(student.candidatE_ID);
        setClass11Castecode(student.cast);
        setClass11Divyangcode(student.divyang);
        setClass11exregularmode("edit");
        navigate("/class-xi-add-ex-regular-info-jac");
      } else {
        setClass11before2010(student);
        setClass11Candidateid(student.candidatE_ID);
        setClass11Castecode(student.cast);
        setClass11Divyangcode(student.divyang);
        setClass11before2010mode("edit");
        navigate("/class-xi-board-registration");
      }
    } catch (error) {
      console.error("Failed to fetch candidate data:", error);
    }
  };

  return (
    <>
      <div class="container-scroller">
        <Navbar11 />
        {isLoading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div class="container-fluid page-body-wrapper">
          <Sidebar11 />
          <div class="main-panel">
            <div class="content-wrapper">
              <section class="content-header">
                <h1>
                  <i class="fa fa-user"></i>&nbsp;Checklist Generated
                </h1>
                <ol class="breadcrumb">
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-dashboard");
                      }}
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginTop: "-4px" }}
                      >
                        <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                      </svg>{" "}
                      Home&nbsp;
                    </a>
                  </li>
                  <li class="active">Checklist Generated</li>
                </ol>
                <h3></h3>
              </section>

              <div class="card">
                <div class="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                      <label htmlFor="rowsPerPage" className="me-2 mb-0">
                        Rows:
                      </label>
                      <div style={{ width: "250px" }}>
                        <select
                          id="rowsPerPage"
                          className="form-select form-select-sm"
                          value={perPage}
                          onChange={handlePerPageChange}
                          style={{
                            width: "80px", // or adjust as needed (80–120px)
                            paddingRight: "2rem", // ensures space for the dropdown arrow
                          }}
                        >
                          {[10, 20, 50, 100, 500].map((num) => (
                            <option key={num} value={num}>
                              {num}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div style={{ width: "200px" }}>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                  </div>
                  {isLoading ? (
                    <p>Loading...</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead className="table-primary">
                          <tr>
                            <th>Sl No.</th>
                            <th>Document Status</th>
                            <th>Checklist Status</th>
                            <th>Category </th>
                            <th>Stream </th>
                            <th>Name of Candidate </th>
                            <th>Gender</th>
                            <th style={{ width: "120px" }}>Date of Birth</th>
                            <th>Father's Name</th>
                            <th>Mother's Name</th>
                            <th>Caste</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="12" className="text-center">
                                No data found.
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((row, index) => (
                              <tr key={index}>
                                <td>
                                  {(currentPage - 1) * perPage + index + 1}
                                </td>
                                <td>
                                  <badge class="badge badge-success">
                                    <i class="fa fa-check"></i>&nbsp;OK
                                  </badge>
                                </td>
                                <td>
                                  <badge class="badge badge-success">
                                    <i class="fa fa-check"></i>&nbsp;Printed
                                  </badge>
                                </td>
                                <td>
                                  <span
                                    style={{
                                      fontWeight: "600",
                                      color: "red",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {row.studenT_EXAM_SUB_CATEGORY || ""}
                                  </span>
                                </td>
                                <td>{row.stream || ""}</td>
                                <td>{row.candidatE_NAME || ""}</td>
                                <td>{row.gender || ""}</td>
                                <td>{row.dob || ""}</td>
                                <td>{row.fatheR_NAME || ""}</td>
                                <td>{row.motheR_NAME || ""}</td>
                                <td>{row.castE_NAME || ""}</td>
                                <td>
                                  {parseDate(currentDate) >=
                                  parseDate(
                                    EndDate
                                  ) ? null : row.challaN_STATUS ===
                                    "GENERATED" ? null : (
                                    <a
                                      className="btn btn-sm btn-primary text-white"
                                      onClick={() =>
                                        handleEdit(row.candidatE_ID)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i className="fa fa-edit"></i>
                                    </a>
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {(currentPage - 1) * perPage + 1} to{" "}
                      {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                      {filteredStudents.length} entries
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <MdOutlineKeyboardDoubleArrowLeft
                        onClick={() => {
                          if (currentPage > 1) setCurrentPage(1);
                        }}
                        style={{
                          cursor: currentPage > 1 ? "pointer" : "not-allowed",
                          opacity: currentPage > 1 ? 1 : 0.5,
                        }}
                      />

                      <MdOutlineKeyboardArrowLeft
                        onClick={() => {
                          if (currentPage > 1)
                            setCurrentPage((prev) => prev - 1);
                        }}
                        style={{
                          cursor: currentPage > 1 ? "pointer" : "not-allowed",
                          opacity: currentPage > 1 ? 1 : 0.5,
                        }}
                      />

                      <span>
                        Page {currentPage} of {totalPages}
                      </span>

                      <MdOutlineKeyboardArrowRight
                        onClick={() => {
                          if (currentPage < totalPages)
                            setCurrentPage((prev) => prev + 1);
                        }}
                        style={{
                          cursor:
                            currentPage < totalPages
                              ? "pointer"
                              : "not-allowed",
                          opacity: currentPage < totalPages ? 1 : 0.5,
                        }}
                      />

                      <MdOutlineKeyboardDoubleArrowRight
                        onClick={() => {
                          if (currentPage < totalPages)
                            setCurrentPage(totalPages);
                        }}
                        style={{
                          cursor:
                            currentPage < totalPages
                              ? "pointer"
                              : "not-allowed",
                          opacity: currentPage < totalPages ? 1 : 0.5,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer11 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Checklistgenerated11;
